//hooks
import { useOutsideClick } from '../../../../util/misc';

//types
import { ISelectProps } from '../types/ISelectProps';

export default function CustomTitleSelect<T>({ name, value, options, onChange }: ISelectProps<T>) {
    const { dropdownRef, isOpen, setIsOpen } = useOutsideClick();

    // билд жса на сайте цепляется за ui-select, ui-select__preview и ui-select__options и ломает селект
    // заменяем их копиями с _
    return (
        <div
            ref={dropdownRef}
            className={
                '_ui-select ui-select--gray' +
                (isOpen ? ' ui-select--opened' : '') +
                (value ? ' ui-select--selected' : '')
            }
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className="_ui-select__preview">
                <div className="ui-select__placeholder">{name}</div>
                <div className={value ? 'ui-select__text ui-select__composed' : 'ui-select__text'}>
                    <span>
                        {name} - &nbsp;
                    </span>
                    <span>
                        {value} 
                    </span>
                </div>
                <div className="ui-select__icon">
                    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.22333 11.3187L9.05151 5.6284L4.22333 -0.0035553L0.0515137 -0.0035553L4.9381 5.6284L0.0515137 11.3187H4.22333Z" fill="#050505"/>
                    </svg>
                </div>
            </div>
            <div className="_ui-select__options">
                <div className="scroll-content" onClick={() => onChange(null)}>
                    <div className="ui-select-option">Все</div>
                </div>
                {isOpen &&
                    options.map(({ name, value }, idx) => (
                        <div key={idx} className="scroll-content" onClick={() => onChange(value)}>
                            <div className="ui-select-option">{name}</div>
                        </div>
                    ))}
            </div>
        </div>
    );
}
